import { getPartnerId } from '../../themes/partnerTheme';
import defaultLanding from './config/defaultLanding';
import avivaLanding from './config/avivaLanding';

/** Register a partner by adding config/<id>Landing.js and an entry here. */
const LANDING_BY_PARTNER = {
  aviva: avivaLanding,
};

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function mergeCopy(base, override) {
  if (!override) return base;
  const next = { ...base, ...override };
  Object.keys(override).forEach((key) => {
    if (isPlainObject(base[key]) && isPlainObject(override[key])) {
      next[key] = { ...base[key], ...override[key] };
    }
  });
  return next;
}

function mergeLanding(base, override) {
  if (!override) return base;
  return {
    ...base,
    ...override,
    images: { ...base.images, ...override.images },
    copy: mergeCopy(base.copy, override.copy),
    disruptionColors: { ...base.disruptionColors, ...override.disruptionColors },
    flags: { ...base.flags, ...override.flags },
    benefitBox: { ...base.benefitBox, ...override.benefitBox },
    surfaces: { ...base.surfaces, ...override.surfaces },
    disruptions: override.disruptions || base.disruptions,
  };
}

/** Resolved landing content, assets, and colours for the active partner. */
export function getLandingConfig() {
  const partnerId = getPartnerId();
  return mergeLanding(defaultLanding, LANDING_BY_PARTNER[partnerId]);
}

export function getLandingCssVars(landing) {
  const colors = landing.disruptionColors || {};
  const box = landing.benefitBox || {};
  const surfaces = landing.surfaces || {};
  const vars = {
    '--landing-why-choose-icons': `url(${landing.images.whyChooseIcons})`,
    '--landing-disruption-blue': colors.blue,
    '--landing-disruption-dark-blue': colors.darkBlue,
    '--landing-disruption-yellow': colors.yellow,
    '--landing-disruption-red': colors.red,
    '--landing-disruption-green': colors.green,
  };

  if (surfaces.accent) {
    vars['--landing-accent'] = surfaces.accent;
    vars['--landing-bcm-bg'] = surfaces.bcmBackground || surfaces.accent;
  }
  if (surfaces.bcmText) vars['--landing-bcm-text'] = surfaces.bcmText;
  if (box.background) vars['--landing-benefit-bg'] = box.background;
  if (box.text) vars['--landing-benefit-text'] = box.text;
  if (box.accent) vars['--landing-benefit-accent'] = box.accent;

  return vars;
}

export function registerLandingPartner(partnerId, config) {
  LANDING_BY_PARTNER[String(partnerId || '').toLowerCase()] = config;
}

export { DISRUPTIONS } from './config/defaultLanding';
